import Vue from 'vue'
import { loadProgressBar } from 'axios-progress-bar'
import VTooltip from 'v-tooltip'
import {
    Globals, Toasters, MessageValidationError, Icon,
} from '@technologyadvice/relay-frontend'
import {
    ValidationObserver, ValidationProvider, extend, setInteractionMode,
} from 'vee-validate'
import {
    integer, double, email, between, required, regex, max, min, min_value as minValue, max_value as maxValue,
} from 'vee-validate/dist/rules'
import {
    moneyMin, moneyMax, moneyMinValue, requiredWith,
} from '@util/CustomValidation.js'
import VueStripe from '@plugins/VueStripe'
import App from './App.vue'
import router from './router'
import { store } from './store'
import 'bootstrap';

Vue.use(VTooltip)
Vue.use(Globals)
Vue.use(Toasters)
Vue.use(VueStripe)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('MessageValidationError', MessageValidationError)
Vue.component('Icon', Icon)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')

loadProgressBar()

setInteractionMode('eager')

// Vee-Validate Rules
// Default Rules
extend('integer', {
    ...integer,
    message: '{_field_} must be a whole number',
})
extend('minValue', {
    ...minValue,
    message: '{_field_} must be {min} or greater',
})
extend('required', required)
extend('regex', regex)
extend('between', {
    ...between,
    message: '{_field_} must be between {min} and {max}.',
})
extend('max', max)
extend('min', min)
extend('maxValue', maxValue)
extend('money_min', moneyMin)
extend('money_min_value', moneyMinValue)
extend('money_max', moneyMax)
extend('email', email)
extend('double', {
    ...double,
    message: '{_field_} must be a valid number with no more than {decimals} decimal places.',
})
extend('required_with', requiredWith)
